import { useEffect, useRef, useState } from "react";
import "./ProjectNameList.css";
import { Icon } from "@iconify/react/dist/iconify.js";

const ProjectNameList = (props) => {

  const { projects, setSelectedProjectId, selectedProjectId, selectedProjectDetails } = props

  const containerRef = useRef(null);
  const [isScrollable, setIsScrollable] = useState(false);

  useEffect(() => {
    const checkScroll = () => {
      const content = document.getElementById('project-scroll-content');
      const wrapper = document.getElementById('project-scroll-wrapper');
      if (content && wrapper) {
        setIsScrollable(content.scrollWidth > wrapper.clientWidth);
      }
    };

    checkScroll();
    window.addEventListener('resize', checkScroll);
    return () => window.removeEventListener('resize', checkScroll);
  }, [projects]);

  const scroll = (direction) => {
    if (!containerRef.current) return;
    containerRef.current.scrollBy({
      left: direction === "left" ? -200 : 200,
      behavior: "smooth",
    });
  };

  return (
    <div style={{ maxWidth: '100vw', overflow: 'hidden' }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          backgroundColor: '#E76A341A',
          padding: '2px',
          width: isScrollable ? '100%' : 'fit-content',
        }}
      >
        {/* Left Scroll Button */}
        {isScrollable && (
          <button
            onClick={() => scroll('left')}
            style={{
              fontSize: '20px',
              padding: '8px 5px 1px 5px',
              borderRadius: '4px',
              cursor: 'pointer',
            }}
          >
            <Icon icon="fluent:ios-arrow-24-filled" width="22" height="22" />
          </button>
        )}

        {/* Scroll Wrapper */}
        <div
          id="project-scroll-wrapper"
          ref={containerRef}
          style={{
            overflowX: 'auto',    // allow horizontal scrolling
            flexGrow: 1,
            maxWidth: '90vw',
            whiteSpace: 'nowrap'  // optional but helps
          }}
        >
          <div
            id="project-scroll-content"
            style={{
              display: 'flex',
              gap: '8px',
              scrollBehavior: 'smooth',
              width: 'max-content',
              marginLeft: isScrollable ? '0px' : '5px',
            }}
          >
            {projects?.map((project) => (
              <div className="section2_list" key={project._id}>
                <button
                  className={project._id === selectedProjectId ? 'first-project' : 'other-project'}
                  onClick={() => {
                    setSelectedProjectId(project._id);
                    selectedProjectDetails(project._id)
                  }}
                >
                  {project.projectName}
                </button>
              </div>
            ))}
          </div>
        </div>

        {/* Right Scroll Button */}
        {isScrollable && (
          <button
            onClick={() => scroll('right')}
            style={{
              fontSize: '20px',
              padding: '7px 5px 3px 5px',
              borderRadius: '4px',
              cursor: 'pointer',
              transform: 'rotate(180deg)',
            }}
          >
            <Icon icon="fluent:ios-arrow-24-filled" width="22" height="22" />
          </button>
        )}
      </div>
    </div>
  );
};

export default ProjectNameList;